import { apiClient } from './client';

export interface ReactionSummary {
  emoji: string;
  count: number;
  users: string[];
}

export interface ToggleResult {
  messageId?: string;
  dmId?: string;
  channelId?: string;
  emoji: string;
  removed: boolean;
  summary: ReactionSummary[];
}

export const reactionsApi = {
  async toggleChannelReaction(messageId: string, emoji: string): Promise<ToggleResult> {
    const res = await apiClient.post<ToggleResult>(`/api/reactions/messages/${messageId}`, { emoji });
    return res.data;
  },
  async toggleDmReaction(dmId: string, emoji: string): Promise<ToggleResult> {
    const res = await apiClient.post<ToggleResult>(`/api/reactions/dm/${dmId}`, { emoji });
    return res.data;
  },
  async getMessageReactions(messageId: string): Promise<ReactionSummary[]> {
    const res = await apiClient.get<ReactionSummary[]>(`/api/reactions/messages/${messageId}`);
    return res.data;
  },
  async getDmReactions(dmId: string): Promise<ReactionSummary[]> {
    const res = await apiClient.get<ReactionSummary[]>(`/api/reactions/dm/${dmId}`);
    return res.data;
  },
};
